import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface ISecondarySearchButtonProps extends IButtonProps {}

export const SecondarySearchButton = ({
  icon = IconNames.search,
  iconPosition = IconPositions.Right,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  paddings = [FIXED_INDENTS.INDENT_40],
  colorDefault = ButtonColors.COLOR_TEXT_SECONDARY,
  colorHovered = ButtonColors.SURFACE_LIGHT_2,
  colorPressed = ButtonColors.COLOR_MAIN_PRESSED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorHovered = COLOR.TRANSPARENT,
  backgroundColorPressed = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.None,
  ...rest
}: ISecondarySearchButtonProps): JSX.Element => (
  <Button
    font={font}
    icon={icon}
    iconPosition={iconPosition}
    iconSize={iconSize}
    corners={corners}
    paddings={paddings}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    backgroundColorDefault={backgroundColorDefault}
    backgroundColorHovered={backgroundColorHovered}
    backgroundColorPressed={backgroundColorPressed}
    backgroundColorDisabled={backgroundColorDisabled}
    borderWidth={borderWidth}
    fluid={fluid}
    {...rest}
  />
)
